var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.818,
    height: 20,
    viewBox: "0 0 15.818 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(-1.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M11.659,1.25c1.747,0,3.164,1.119,3.164,2.5v5H8.5v-5C8.5,2.369,9.912,1.25,11.659,1.25ZM16.4,8.75v-5C16.4,1.679,14.28,0,11.659,0S6.914,1.679,6.914,3.75v5c-1.747,0-3.164,1.119-3.164,2.5V17.5c0,1.381,1.416,2.5,3.164,2.5H16.4c1.747,0,3.164-1.119,3.164-2.5V11.25C19.568,9.869,18.152,8.75,16.4,8.75ZM6.914,10H16.4a1.446,1.446,0,0,1,1.582,1.25V17.5A1.446,1.446,0,0,1,16.4,18.75H6.914A1.446,1.446,0,0,1,5.332,17.5V11.25A1.446,1.446,0,0,1,6.914,10Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.b89e55043a0c9e52fe741fb937ab98c8.svg";
export { ForwardRef as ReactComponent };